module.exports = __webpack_public_path__ + "static/img/changJingImg5.3a4daa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/changJingImg5.png
// module id = XPHz
// module chunks = 2